import $ from 'jquery';
import changeWindowUrl from './utils/change-url';
import empty from './utils/empty';

class PrevNextBtns {
    constructor($selector, $chapters) {
        this.$btns = $selector;
        this.$chapters = $chapters;
        this.$header = $('.js-header');
        this.$landingCover = $('.js-landing-cover');
        this.$links = $('.js-contents-list').find('.js-contents-list__link');
        this.$subContentListItems = $('.js-sub-contents-list__item');

        this.$btns.on('click', $.proxy(this.goTo, this));
        $(window).on('load', $.proxy(this.urlChanged, this));
        $(window).on('hashchange', $.proxy(this.urlChanged, this));

    }

    getCurrentChapter() {
        return this.$chapters.filter(function () {
            return $(this).hasClass('is-current');
        });
    }

    getNextChapter($currentChapter, dir) {
        if ($currentChapter.length) {
            if (dir === 'prev') {
                return $currentChapter.prev('.js-chapter');
            } else {
                return $currentChapter.next('.js-chapter');
            }
        } else {
            if (dir === 'prev') {
                return this.$chapters.last();
            } else {
                return this.$chapters.first();
            }
        }
    }

    goTo(e) {
        e.preventDefault();

        const $elem = $(e.currentTarget);
        const dir = $elem.data('dir');
        const $currentChapter = this.getCurrentChapter(dir);
        const $nextChapter = this.getNextChapter($currentChapter, dir);
        const id = $nextChapter.prop('id');

        if (id && !$elem.hasClass('is-disabled')) {
            changeWindowUrl(`${id}`, true, false);
            let top = $(`#${id}`).offset().top;

            //for first chapter get the height of cover
            if (this.$header.length) {
                top = this.$header.outerHeight(true) - 80;
            }

            if ($('body').hasClass('is-landing-page')) {
                top += this.$landingCover.outerHeight(true);
            }

            $('html,body').animate({
                scrollTop: top
            }, 400);

            this.setActiveClass();
            this.$subContentListItems.removeClass('is-active');
        }
    }

    urlChanged() {
        const $currentChapter = this.getCurrentChapter();
        const index = $currentChapter.index();

        this.togglePrev(index);
        this.toggleNext(index);
    }

    togglePrev(index) {
        const $btn = this.$btns.filter(function () {
            return $(this).data('dir') === 'prev';
        });
        if (index <= 0) {
            $btn.addClass('is-disabled');
        } else {
            $btn.removeClass('is-disabled');
        }
    }

    toggleNext(index) {
        const $btn = this.$btns.filter(function () {
            return $(this).data('dir') === 'next';
        });
        if (index + 1 >= this.$chapters.length) {
            $btn.addClass('is-disabled');
        } else {
            $btn.removeClass('is-disabled');
        }
    }

    setActiveClass() {
        const chapterID = this.getCurrentChapter().prop('id');

        this.$links.removeClass('is-active');
        this.$links.each(function () {
            const linkHref = $(this).attr('href');
            if (chapterID === linkHref) {
                $(this).addClass('is-active');
            }

            if ($(this).hasClass('is-active')) {
                setTimeout(() => {
                    $(this).next('.js-sub-list-button').trigger('click');
                }, 100);
            }
        });
    }

}

export default PrevNextBtns;
